import { useCallback, useMemo } from "react";

import { useParsedCookie } from "~/lib/hooks";

export const useSCMPExperimentCookie = () => {
  const { update, value } = useParsedCookie("scmp_exp_10005_variant", raw => raw, {
    initializeWithValue: true,
  });

  const isExperimentBetaTesting = useMemo(() => value === "c", [value]);

  const setExperimentCookieAsOriginal = useCallback(() => {
    update("x");
  }, [update]);

  return {
    isExperimentBetaTesting,
    setExperimentCookieAsOriginal,
    value,
  };
};
